import { EffectivenessMap } from 'components/reports/EffectivenessMap';
import { Color } from 'core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export function SiteAdminEffectivenessMap() {
  const { t } = useTranslation();

  return (
    <Container>
      <Header>
        <Title>{t('Effectiveness Map')}</Title>
        <Subtitle>
          {t('Visualize learner progress vs knowledge retention to identify who is retaining knowledge and who may need review.')}
        </Subtitle>
      </Header>
      <EffectivenessMap />
    </Container>
  );
}

const Container = styled.div`
  padding: 20px;
  min-height: 100vh;
  background-color: ${Color.grayTransparent};
`;

const Header = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${Color.primaryBlack};
  margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: ${Color.textGray};
  margin: 0;
`;
